import React from "react";
import { Calendar, Clock, Trophy } from "lucide-react";
import { formatAppDate, formatAppTime } from "../../../utils/appTimeFormat";

const parseKickoff = (ts) => {
  if (ts == null) return { dateStr: "", timeStr: "" };
  try {
    const d = new Date(Number(ts) > 1e12 ? ts : ts * 1000);
    return {
      dateStr: formatAppDate(d),
      timeStr: formatAppTime(d),
    };
  } catch {
    return { dateStr: "", timeStr: "" };
  }
};

const H2HMatchContext = ({ fixture, variant = "detail" }) => {
  const home = fixture?.teams?.home?.name;
  const away = fixture?.teams?.away?.name;
  if (!home || !away) return null;

  const homeLogo = fixture?.teams?.home?.logo;
  const awayLogo = fixture?.teams?.away?.logo;
  const { dateStr, timeStr } = parseKickoff(fixture?.timestamp);
  const league = fixture?.league?.name;
  const leagueLogo = fixture?.league?.logo;
  const statusShort = String(fixture?.status?.short ?? "").trim() || "—";
  const homeGoals = fixture?.goals?.home;
  const awayGoals = fixture?.goals?.away;
  const hasScore =
    homeGoals != null && awayGoals != null && !Number.isNaN(Number(homeGoals));

  return (
    <div className={`bp-h2h-context${variant === "detail" ? " bp-h2h-context-detail" : ""}`}>
      {(league || dateStr || timeStr) && (
        <div className="bp-h2h-context-top">
          {league ? (
            <div className="bp-h2h-league">
              {leagueLogo ? (
                <img src={leagueLogo} alt="" />
              ) : (
                <Trophy size={12} strokeWidth={2.25} />
              )}
              <span>{league}</span>
            </div>
          ) : (
            <span />
          )}
          <div className="bp-h2h-schedule">
            {dateStr ? (
              <span>
                <Calendar size={11} />
                {dateStr}
              </span>
            ) : null}
            {timeStr ? (
              <span>
                <Clock size={11} />
                {timeStr}
              </span>
            ) : null}
          </div>
        </div>
      )}

      <div className="bp-h2h-scoreboard">
        <div className="bp-h2h-team bp-h2h-team-home">
          {homeLogo ? <img src={homeLogo} alt="" /> : <span className="bp-h2h-logo-ph" />}
          <strong>{home}</strong>
          {hasScore ? <span className="bp-h2h-goals">{homeGoals}</span> : null}
        </div>

        <div className="bp-h2h-vs">
          <span className="bp-h2h-vs-chev">⟨</span>
          <span className="bp-h2h-vs-pill">{statusShort}</span>
          <span className="bp-h2h-vs-chev">⟩</span>
        </div>

        <div className="bp-h2h-team bp-h2h-team-away">
          {hasScore ? <span className="bp-h2h-goals">{awayGoals}</span> : null}
          {awayLogo ? <img src={awayLogo} alt="" /> : <span className="bp-h2h-logo-ph" />}
          <strong>{away}</strong>
        </div>
      </div>
    </div>
  );
};

export default H2HMatchContext;
